'use strict';

function EditClub() {
    $('#edit-btn').hide();
    $('.read-field').hide();
    $('.edit-area').show();
    $('#save-btn').show();
    tinymce.init({
        selector: '.edit-field',
        branding: false,
        block_formats: '',
        menubar: false,
        browser_spellcheck: true,
        language: 'nb_NO',
        toolbar1: 'undo redo | bold italic | numlist bullist',
        plugins: "lists"
    });
}

$('#club-edit-form').submit(function () {

    var form = $('#club-edit-form');
    form.validate();
    var isFormValid = form.valid();
    if (isFormValid) {
        btnAnimation();
        var currentClubId = $('#CurrentClub_Id').val();
        var description = tinyMCE.get('description-input').getContent();
        var email = document.getElementById('email-input').value;
        var website = document.getElementById('website-input').value;
        var name = document.getElementById('name-input').value;
        var contactPersons = tinyMCE.get('contactpersons-input').getContent();
        var anno = document.getElementById('anno-input').value;
        var address = document.getElementById('address-input').value;
        var heading = document.getElementById('heading-input').value;
        var visitAddress = document.getElementById('visitingadress-input').value;

        var dataToSave = {
            Id: currentClubId,
            Description: description,
            Email: email,
            Website: website,
            Name: name,
            ContactPersons: contactPersons,
            Anno: anno,
            Address: address,
            Heading: heading,
            VisitAddress: visitAddress
        };

        axios.post('/klubber/edit', dataToSave).then(function (res) {
            location.reload();
        }).catch(function (error) {
            alert("Beklager. En feil oppstod.");
            console.log(error);
        });
    } else {
        return false;
    }
});